import React from "react";
import "../../../assets/scss/vendor_scss/calander.scss";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { calanderDateFormater } from "../../utils/dateCalculater";
import { DateType, ranges } from "./utlits";

export interface IVendorCalanderProps {
  isCalander: boolean;
  date: DateType;
  setDate: (frmDt: Date, toDt: Date) => void;
  setIsCalander: (value: boolean) => void;
}

const VendorCalander: React.FC<IVendorCalanderProps> = (props) => {
  const [showCalander, setShowCalander] = React.useState<boolean>(false);
  const [dateRange, setdDateRange] = React.useState();
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  console.log("dateRange", dateRange);
  const heandelApplyBtn = () => {
    if (dateRange) {
      handelCalanderBtn(dateRange);
      setShowCalander(false);
    }
  };
  const handelCalanderBtn = (val: any) => {
    props.setDate(val[0], val[1]);
  };

  return (
    <div id="vendor_calander" className="vendor_calander">
      {props.isCalander && (
        <div className="vendor_calander_container">
          <ul className="vendor_calander_list">
            <li
              onClick={() => {
                const getDate = ranges["last_7_days"];
                handelCalanderBtn(getDate);
              }}
            >
              Last 7 Days
            </li>
            <li
              onClick={() => {
                const getDate = ranges["last_30_days"];
                handelCalanderBtn(getDate);
              }}
            >
              Last 30 Days
            </li>
            <li
              onClick={() => {
                const getDate = ranges["this_month"];
                handelCalanderBtn(getDate);
              }}
            >
              This Month
            </li>
            <li
              onClick={() => {
                const getDate = ranges["last_month"];
                handelCalanderBtn(getDate);
              }}
            >
              Last Month
            </li>
            <li onClick={() => setShowCalander(true)}>Custom Range</li>
          </ul>
          {showCalander && (
            <div className="calander_box">
              <Calendar
                className="react-calendar "
                defaultValue={new Date()}
                next2Label={null}
                prev2Label={null}
                maxDate={new Date()}
                showDoubleView={windowWidth > 700 ? true : false}
                formatMonthYear={(locale, date) =>
                  date.toLocaleString(locale, {
                    month: "short",
                    year: "2-digit",
                  })
                }
                onChange={(value: any, e: any) => setdDateRange(value)}
                selectRange={true}
                showFixedNumberOfWeeks={true}
                // showNeighboringMonth={true}
                formatShortWeekday={(locale, value) =>
                  ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][value.getDay()]
                }
              />
              <div className="calander_box_footer">
                <span>
                  {calanderDateFormater(props.date.frmDt)} -{" "}
                  {calanderDateFormater(props.date.toDt)}
                </span>
                <div>
                  <button
                    className="text_btn pointer"
                    onClick={() => {
                      setShowCalander(!showCalander);
                      props.setIsCalander(!props.isCalander);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => heandelApplyBtn()}
                    className="text_btn pointer"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VendorCalander;
